import Vue from 'vue'
import App from '@/App'
import router from '@/router'
import store from '@/store'
import VueCookie from 'vue-cookie'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import $ from 'jquery'
import { hasBtnPermission } from '@/utils/permission';
import {getCrumbsList} from '@/utils/crumbs';
Vue.prototype.$hasPerm = hasBtnPermission
Vue.prototype.$crumbsList = getCrumbsList
Vue.prototype.$ = $; //jq引入

import "@/plugins/ztree/js/jquery-3.2.1.min";
import "@/plugins/ztree/js/jquery.ztree.core.js";
import "@/plugins/ztree/js/jquery.ztree.excheck";
import "@/plugins/ztree/css/zTreeStyle2/zTreeStyle.css";

Vue.use(ElementUI)
import '@/icons'
import '@/element-ui-theme'
import '@/assets/scss/index.scss'
import common from '@/utils/common'
import httpTAG from '@/utils/httpTAG'
Vue.use(VueCookie)
Vue.use(common)

import waterfall from 'vue-waterfall2'
Vue.use(waterfall)

Vue.config.productionTip = false

// 挂载全局
Vue.prototype.$httpTAG = httpTAG // ajax请求方法

new Vue({
    router,
    store,
    ...App,
}).$mount('#app')